export default [
  {
    constant: false,
    inputs: [{ name: '_hash', type: 'bytes32' }],
    name: 'releaseDeed',
    outputs: [],
    payable: false,
    type: 'function'
  },
  {
    constant: true,
    inputs: [{ name: '_hash', type: 'bytes32' }],
    name: 'getAllowedTime',
    outputs: [{ name: 'timestamp', type: 'uint256' }],
    payable: false,
    type: 'function'
  },
  {
    constant: false,
    inputs: [{ name: 'unhashedName', type: 'string' }],
    name: 'invalidateName',
    outputs: [],
    payable: false,
    type: 'function'
  },
  {
    constant: true,
    inputs: [{ name: '_hash', type: 'bytes32' }],
    name: 'entries',
    outputs: [
      { name: '', type: 'uint8' },
      { name: '', type: 'address' },
      { name: '', type: 'uint256' },
      { name: '', type: 'uint256' },
      { name: '', type: 'uint256' }
    ],
    payable: false,
    type: 'function'
  },
  {
    constant: true,
    inputs: [],
    name: 'ens',
    outputs: [{ name: '', type: 'address' }],
    payable: false,
    type: 'function'
  },
  {
    constant: false,
    inputs: [{ name: '_hash', type: 'bytes32' }],
    name: 'transferRegistrars',
    outputs: [],
    payable: false,
    type: 'function'
  },
  {
    constant: true,
    inputs: [{ name: '_hash', type: 'bytes32' }],
    name: 'state',
    outputs: [{ name: '', type: 'uint8' }],
    payable: false,
    type: 'function'
  },
  {
    constant: false,
    inputs: [
      { name: '_hash', type: 'bytes32' },
      { name: 'newOwner', type: 'address' }
    ],
    name: 'transfer',
    outputs: [],
    payable: false,
    type: 'function'
  },
  {
    constant: true,
    inputs: [
      { name: '_hash', type: 'bytes32' },
      { name: '_timestamp', type: 'uint256' }
    ],
    name: 'isAllowed',
    outputs: [{ name: 'allowed', type: 'bool' }],
    payable: false,
    type: 'function'
  },
  {
    constant: true,
    inputs: [],
    name: 'registryStarted',
    outputs: [{ name: '', type: 'uint256' }],
    payable: false,
    type: 'function'
  },
  {
    constant: true,
    inputs: [],
    name: 'launchLength',
    outputs: [{ name: '', type: 'uint32' }],
    payable: false,
    type: 'function'
  },
  {
    constant: false,
    inputs: [{ name: 'labels', type: 'bytes32[]' }],
    name: 'eraseNode',
    outputs: [],
    payable: false,
    type: 'function'
  },
  {
    constant: false,
    inputs: [
      { name: 'hash', type: 'bytes32' },
      { name: 'deed', type: 'address' },
      { name: 'registrationDate', type: 'uint256' }
    ],
    name: 'acceptRegistrarTransfer',
    outputs: [],
    payable: false,
    type: 'function'
  },
  {
    constant: true,
    inputs: [],
    name: 'rootNode',
    outputs: [{ name: '', type: 'bytes32' }],
    payable: false,
    type: 'function'
  },
  {
    inputs: [
      { name: '_ens', type: 'address' },
      { name: '_rootNode', type: 'bytes32' },
      { name: '_startDate', type: 'uint256' }
    ],
    payable: false,
    type: 'constructor'
  },
  {
    anonymous: false,
    inputs: [
      { indexed: true, name: 'hash', type: 'bytes32' },
      { indexed: true, name: 'owner', type: 'address' },
      { indexed: false, name: 'value', type: 'uint256' },
      { indexed: false, name: 'registrationDate', type: 'uint256' }
    ],
    name: 'HashRegistered',
    type: 'event'
  },
  {
    anonymous: false,
    inputs: [
      { indexed: true, name: 'hash', type: 'bytes32' },
      { indexed: false, name: 'value', type: 'uint256' }
    ],
    name: 'HashReleased',
    type: 'event'
  },
  {
    anonymous: false,
    inputs: [
      { indexed: true, name: 'hash', type: 'bytes32' },
      { indexed: true, name: 'name', type: 'string' },
      { indexed: false, name: 'value', type: 'uint256' },
      { indexed: false, name: 'registrationDate', type: 'uint256' }
    ],
    name: 'HashInvalidated',
    type: 'event'
  }
];
